module.exports = __webpack_public_path__ + "static/img/s_1@2x.1b70b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s_1@2x.png
// module id = 1/1I
// module chunks = 2